import CastList from '@/pages/cast/CastList.vue';
import CastSubmit from '@/pages/cast/CastSubmit.vue';
import EditorPickCategory from '@/pages/cast/EditorPickCategory';
import CastBestManage from '@/pages/cast/BestManage';
import CastModify from '@/pages/cast/CastModify.vue';

export default {
	CastList: {
		id: 'CastList',
		title: '캐스트 관리',
		heading: '캐스트 관리',
		path: '/cast/list',
		component: CastList,
	},
	CastSubmit: {
		id: 'CastSubmit',
		title: '캐스트 등록',
		heading: '캐스트 등록',
		path: '/cast/submit',
		component: CastSubmit,
	},
	EditorPickCategory: {
		id: 'EditorPickCategory',
		title: '캐스트 카테고리 관리',
		heading: '캐스트 카테고리 관리',
		path: '/cast/editor-pick/categories',
		component: EditorPickCategory,
	},
	CastBestManage: {
		id: 'CastBestManage',
		title: '베스트캐스트 관리',
		heading: '베스트캐스트 관리',
		path: '/cast/best-manage',
		component: CastBestManage,
	},
	CastModify: {
		id: 'CastModify',
		title: '캐스트 조회/수정',
		heading: '캐스트 조회/수정',
		path: '/cast/:castId',
		component: CastModify,
	},
};
